const pause = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7 2.75v10.5H4V2.75zm5 0v10.5H9V2.75z"/></svg>',
};

export { pause as default };
